import { CanActivateFn } from '@angular/router';

/**
 * The OAuth consent page (/authorize) needs a Zil Money CUSTOMER, not a
 * signed-in developer, and that sign-in happens on the page itself. Nothing is
 * left to gate here; the route may drop this guard.
 */
export const consentGuard: CanActivateFn = () => true;
